import { HasProperty } from "../../Helpers/helper";
import ResponseModel from "./ResponseModel";
import { AxiosResponse } from "axios";

export default class ApiResponseModel {
    Success!: boolean;
    Message?: string[];
    Data?: any;

    constructor(response: AxiosResponse) {
        const handle = new ResponseModel(response);

        this.Data = undefined;

        if (HasProperty(response, "data") && HasProperty(response.data, "data") && HasProperty(response.data.data, "$values"))
            this.Data = response.data.data.$values
        else if (HasProperty(response, "data") && HasProperty(response.data, "data") && response.data.data != null)
            this.Data = response.data.data;

        this.Message = handle.Message;
        this.Success = handle.Success;
    }
}